import { AnbFormGroup } from '@anb/ng-forms/public_api';
import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import * as IBAN from 'iban';

function validateIban(formControl: AbstractControl): ValidationErrors | null {
  if (!IBAN.isValid(formControl.value)) {
    return { invalid: true };
  }
  return null;
}

export const NumericValidator = Validators.pattern('^[0-9]*$');
export const KBOValidator = Validators.pattern('^[01]{1}!*([0-9]!*){9}$');

@Injectable()
export class FormValidatorService {
  constructor() {}

  setValidatorRequiredIban(formGroup: AnbFormGroup, required: boolean, path: string): void {
    if (required) {
      formGroup.get(path).setValidators([Validators.required, validateIban]);
    } else {
      formGroup.get(path).setValidators([]);
    }
    formGroup.get(path).updateValueAndValidity({ emitEvent: false });
  }

  setKboNummerValidator(formGroup: AnbFormGroup, required: boolean, path: string): void {
    if (required) {
      formGroup.get(path).setValidators([KBOValidator, Validators.required]);
    } else {
      formGroup.get(path).setValidators([]);
    }

    formGroup.get(path).updateValueAndValidity({ emitEvent: false });
  }

  setValidatorRequired(formGroup: AnbFormGroup, required: boolean, path: string, validators: ValidatorFn | ValidatorFn[] | null = []) {
    if (!Array.isArray(validators)) {
      validators = [validators];
    }

    if (required) {
      formGroup.get(path).setValidators([Validators.required, ...validators]);
    } else {
      formGroup.get(path).setValidators([]);
    }
    formGroup.get(path).updateValueAndValidity({ emitEvent: false });
  }
}
